var _clipPath, _clipPath2, _clipPath3, _style;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHome = function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Home_svg__Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 59.54 61"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Home_svg__clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M3.54 5h51v51h-51z"
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "Home_svg__clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "Home_svg__cls-2",
    d: "M53.59 48.15h-5.13v-.9a6.28 6.28 0 0 0 5.47-6.16c0-2.11-1.34-8.49-3.76-11.42l.13-.05a2.7 2.7 0 0 0 1.59-2.46 2.68 2.68 0 0 0-1-2.12L31 9.21a1 1 0 0 0-1.19 0l-8.36 6.52v-.8h.12a.93.93 0 1 0 0-1.85H14a.93.93 0 1 0 0 1.85h.11v6.54L10 24.69a2.71 2.71 0 0 0 .53 4.61 2.85 2.85 0 0 0 3-.33l1.3-1v9.57a6.23 6.23 0 0 0-4.48 3.75h-.25a4.28 4.28 0 0 0-4.32 4.21 4.19 4.19 0 0 0 1 2.65H4.49a.93.93 0 1 0 0 1.85h49.1a.93.93 0 1 0 0-1.85ZM16 18.32h.65a.46.46 0 1 0 0-.92H16v-2.48h3.56V16h-.69a.47.47 0 1 0 0 .93h.69v.27L16 20Zm-3.73 9.2a.92.92 0 0 1-.95.11.87.87 0 0 1-.18-1.49l19.26-15 19.27 15.34a.88.88 0 0 1 .32.68.84.84 0 0 1-.51.78.88.88 0 0 1-.94-.11l-2.63-2.1a1 1 0 0 0-.22-.25L31 13.86h-.06l-.08-.06h-.14a.86.86 0 0 0-.28 0H29.87l-.07.05Zm34.09 1-.31.18v-.43ZM9.75 48.15a.78.78 0 0 0-.29-.15 2.59 2.59 0 0 1-2-2.51 2.62 2.62 0 0 1 2.65-2.59 2.65 2.65 0 0 1 1.63.55.86.86 0 0 0 1.18-.14.81.81 0 0 0-.14-1.15 4.91 4.91 0 0 0-.85-.51 4.67 4.67 0 0 1 2.83-2.44v8.93Zm16.85 0h7.59V34.37H26.6Zm17.54 0h-8.06v-14.7a.94.94 0 0 0-.94-.93h-9.49a1 1 0 0 0-.95.93v14.7h-8.06v-21.5l13.75-10.89 13.75 11v4.14a25.84 25.84 0 0 0-2.93 10.23 6.2 6.2 0 0 0 2.93 5.24Zm2.43 0H46v-1l.53.1Zm1-7.22a.94.94 0 0 0-1 .93v3.48a4.39 4.39 0 0 1-3.47-4.25 24.33 24.33 0 0 1 1.53-6.78c1.1-3 2.27-4.3 2.94-4.3s1.83 1.33 2.94 4.3A24.24 24.24 0 0 1 52 41.09a4.4 4.4 0 0 1-3.57 4.28v-3.51a.94.94 0 0 0-.91-.93Z"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "Home_svg__clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "Home_svg__cls-2",
    d: "M31 22a4.5 4.5 0 1 0 4.5 4.5A4.51 4.51 0 0 0 31 22m0 2.08a2.43 2.43 0 0 1 2 1h-4a2.41 2.41 0 0 1 2-1m0 4.84a2.42 2.42 0 0 1-2.42-2.42 2.07 2.07 0 0 1 0-.35h4.79a2.07 2.07 0 0 1 0 .35A2.42 2.42 0 0 1 31 28.92"
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "Home_svg__clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "Home_svg__cls-2",
    d: "M27.58 42.69a.41.41 0 0 0 .05.09l.06.07a.19.19 0 0 0 .07.06l.09.05h.38l.09-.05a.21.21 0 0 0 .08-.06.5.5 0 0 0 .14-.35.31.31 0 0 0 0-.1.19.19 0 0 0 0-.1v-.08l-.06-.08a.51.51 0 0 0-.86.36s0 .06 0 .1v.09"
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".Home_svg__cls-2{fill:none;clip-rule:evenodd}.Home_svg__cls-6{fill:#061d2d}"))), /*#__PURE__*/React.createElement("path", {
    className: "Home_svg__cls-6",
    d: "M-1.46 4h61v51h-61z",
    style: {
      clipPath: "url(#Home_svg__clip-path-2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "Home_svg__cls-6",
    d: "M21.54 17h19v19h-19z",
    style: {
      clipPath: "url(#Home_svg__clip-path-3)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "Home_svg__cls-6",
    d: "M22.54 37h11v11h-11z",
    style: {
      clipPath: "url(#Home_svg__clip-path-4)"
    }
  }));
};
export default SvgHome;